/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PersonalDataStatus = 'READY' | 'UNPAID_AND_READY' | 'UNPAID_AND_PENDING' | 'PENDING' | 'UNKNOWN';

export const PersonalDataStatus = {
    READY: 'READY' as PersonalDataStatus,
    UNPAID_AND_READY: 'UNPAID_AND_READY' as PersonalDataStatus,
    UNPAID_AND_PENDING: 'UNPAID_AND_PENDING' as PersonalDataStatus,
    PENDING: 'PENDING' as PersonalDataStatus,
    UNKNOWN: 'UNKNOWN' as PersonalDataStatus
};

